export enum RolesTypes {
  GET_ROLES = '@@roles/GET_ROLES',
  GET_ROLES_SUCCESS = '@@roles/GET_ROLES_SUCCESS',
  GET_ROLES_FAIL = '@@roles/GET_ROLES_FAIL',

  GET_ROLES_DETAIL = '@@roles/GET_ROLES_DETAIL',
  GET_ROLES_DETAIL_SUCCESS = '@@roles/GET_ROLES_DETAIL_SUCCESS',
  GET_ROLES_DETAIL_FAIL = '@@roles/GET_ROLES_DETAIL_FAIL',

  ADD_ROLES = '@@roles/ADD_ROLES',
  ADD_ROLES_SUCCESS = '@@roles/ADD_ROLES_SUCCESS',
  ADD_ROLES_FAIL = '@@roles/ADD_ROLES_FAIL',

  DELETE_ROLES = '@@roles/DELETE_ROLES',
  DELETE_ROLES_SUCCESS = '@@roles/DELETE_ROLES_SUCCESS',
  DELETE_ROLES_FAIL = '@@roles/DELETE_ROLES_FAIL',

  UPDATE_ROLES = '@@roles/UPDATE_ROLES',
  UPDATE_ROL_PERMISSIONS = '@@roles/UPDATE_ROL_PERMISSIONS',
  UPDATE_ROLES_SUCCESS = '@@roles/UPDATE_ROLES_SUCCESS',
  UPDATE_ROLES_FAIL = '@@roles/UPDATE_ROLES_FAIL',
}
